module.exports = __webpack_public_path__ + "static/media/apresentacao-bb.b9567cfa.png";